import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Components/Form";
import toast from "react-hot-toast";
import Header from "../../../../Components/Header";
import {
  create_milestone,
  get_milestone,
  update_milestone,
} from "../../../../Controllers/About/Milestones";
import forms from "../../../../Data/Forms/About/Milestones/forms";
import headers from "../../../../Data/Forms/About/Milestones/headers";
import Loadercomponent from "../../../../Components/Loader";
import AddButton from "../../../../Components/Buttons/add";
import RemoveButton from "../../../../Components/Buttons/delete";
import { convert_to_file } from "../../../../Controllers/Global";

const AboutMilestonesForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const milestone = id
        ? await update_milestone({ ...data?.data, id: id })
        : await create_milestone(data?.data);

      if (milestone?.status) {
        if (id) {
          navigate(-1);
        }
        toast?.success(milestone?.message);
        setButtonLoader(false);
      } else {
        toast?.error(milestone?.message);
        setButtonLoader(false);
      }
    }
  };

  const handleData = async (milestone) => {
    let title = milestone?.title ? milestone?.title : "";
    let description = milestone?.description ? milestone?.description : "";
    let status = milestone?.status ? milestone?.status : 0;

    forms[0].options[0].form.value = title;
    forms[0].options[1].form.value = description;
    forms[0].options[2].form.value = status;

    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const milestone = await get_milestone(data);
      if (milestone?.status) {
        handleData(milestone?.data);
      } else {
        toast?.error(milestone?.message);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={headers}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        />
      </Loadercomponent>
    </Header>
  );
};

export default AboutMilestonesForm;
